export default {
  id: '5',
  title: '脑卒中防再梗服务',
  createTime: '2025-03-22 10:00:00',
  content: `![img](https://cdn.keihong.tech/img/20250422161736834.png)

专为脑卒中患者设计的12个月全方位康复防护方案，防止二次中风发生。

1） **智能设备支持**：远程康复仪、居家运动工具包和5种智能身体检测设备
2） **专业评估指导**：首次免费线上/线下评估，每月2次视频问诊（20分钟/次）
3） **康复训练方案**：每月2套个性化居家训练方案，专为脑卒中患者设计
4） **全程效果追踪**：每季度一次康复效果评定（共4次），确保康复进度
5） **终身健康守护**：提供终身客户线上咨询与随访，持续健康管理

咨询电话：18520535303

添加二维码：

![img](https://cdn.keihong.tech/img/20250422161736732.png)`
}
